<template>
    <div>
        <div v-if="options_loaded && passed_filter">
            <template v-if="filtered_option_list.length > 0 && filtered_option_list[0].value !== null">
                <div class="designeroption" :data-designer-component-id="component_id">
                    <h3>{{ title }}</h3>
                    <div class="stylesoption selectoption form-group">
                        <select :id="'question--' + component_id" class="form-control" v-model="localTarget" v-if="!loading">
                            <option v-for="option in filtered_option_list" :value="option.value">{{ option.label }}</option>
                        </select>
                        <select :id="'question--' + component_id" disabled class="form-control" v-if="loading">
                            <option>Loading Options...</option>
                        </select>
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>

<script type="text/ecmascript-6">
    import Question from "../mixin/Question.vue";

    export default {
        mixins: [
            Question,
        ],
        props: {
            title: {
                default(){
                    return 'Drainage';
                }
            },
            component_id: {
                default(){
                    return 'drainage';
                }
            },
            cill: {
                required: true
            },
            threshold: {
                required: true
            },
        },
        computed: {
            passed_filter(){
                return this.variable_ready(this.cill, this.threshold);
            },
            url(){
                return '/api/options/' + this.fabricator + '/technical-drainage?cill=' + this.cill + '&threshold=' + this.threshold;
            },
            cache_key(){
                return '_' + this.cill + '_' + this.threshold;
            }
        },
        watch: {
            'cill': function (val, oldVal) {
                this.localTarget = null;
                this.select_first_after_update = true;
                this.update_options();
            },
            'threshold': function (val, oldVal) {
                this.localTarget = null;
                this.select_first_after_update = true;
                this.update_options();
            },
        }
    }
</script>
